<mat-card appearance="outlined" class="mat-elevation-z1 mat-card-scrollable">
    @if (!isLoading) {
        <mat-card-header>
            <mat-card-title>{{ 'GeneralMeeting.Title' | translate }}</mat-card-title>
        </mat-card-header>
        <mat-card-content class="container">
            <div class="block">
                <div class="heading">
                    {{ currentShareholderData.displayName }}
                </div>
            </div>

            <div class="block">
                <div>
                    {{ 'GeneralMeeting.Votes' | translate }}
                </div>
                <div class="data">
                    {{ currentShareholderData.votes | slNumber }}
                </div>
            </div>

            <div class="block">
                <div>{{ 'GeneralMeeting.WebInstructionsToDate' | translate }}</div>
                <div class="data">{{ currentMeeting.webInstructionsToDate | localizedDate: 'mediumCustom' }}</div>
            </div>

            <div class="block">
                <div>{{ 'GeneralMeeting.Status' | translate }}</div>
                <div class="data">
                    <p class="mb-0">{{ statusDescription }}</p>
                    @if (
                        registrationStatus === RegistrationStatusEnum.IndependentRepresentative
                        && !!instructions
                        && instructions.instructions.length > 0
                    ) {
                        <a mat-button routerLink="/general-meeting-registration-print">
                            <mat-icon>print</mat-icon>
                            {{ 'General.Print' | translate }}
                        </a>
                    }
                    @if (currentShareholderData.canRequestEmailAgain) {
                        <button mat-button (click)="resendAdmissionCardEmail()" [disabled]="isSendingAdmissionCardEmail">
                            <mat-icon>email</mat-icon>
                            {{ 'GeneralMeeting.ResendAdmissionCardEmail' | translate }}
                        </button>
                    }
                </div>
            </div>
        </mat-card-content>
        <mat-card-actions>
            <div class="row no-gutters w-100">
                @switch (getTemplateName()) {
                    @case ('instructionsTempl') {
                        <div class="col-12">
                            @if (shouldAllowWebRegistrationSelf) {
                                <button
                                    class="w-100"
                                    mat-stroked-button
                                    [disabled]="
                                        !shouldAllowWebInstructionsChange || registrationStatus === RegistrationStatusEnum.Attending
                                    "
                                    (click)="onSelfAttend()">
                                    <span class="wrapper">
                                        <span class="material-icons">person</span>
                                        <span>
                                            {{
                                                (registrationStatus === RegistrationStatusEnum.Attending
                                                    ? 'GeneralMeeting.SelfAttendRequested'
                                                    : 'GeneralMeeting.SelfAttendRequest'
                                                ) | translate
                                            }}
                                        </span>
                                    </span>
                                </button>
                            }
                        </div>
                        <div class="col-12 mt-2">
                            @if (shouldAllowWebRegistrationIndependentProxy) {
                                <button
                                    class="w-100"
                                    mat-stroked-button
                                    [disabled]="!shouldAllowWebInstructionsChange"
                                    (click)="onGiveInstructions()">
                                    <span
                                        class="text-wrap"
                                        [matTooltip]="'GeneralMeeting.WebInstructionsToDateExpired' | translate"
                                        [matTooltipDisabled]="shouldAllowWebInstructionsChange">
                                        <span class="material-icons">how_to_vote</span>
                                        <span>{{ instructionsButtonText }}</span>
                                    </span>
                                </button>
                            }
                        </div>
                    }
                    @case ('checkOutTempl') {
                        <div class="col-12 col-md-6">
                            @if (shouldAllowWebAttendance) {
                                <button class="w-100" mat-stroked-button (click)="onCheckOut()" color="warn">
                                    {{ 'GeneralMeeting.CheckOut' | translate }}
                                </button>
                            }
                        </div>
                    }
                    @case ('checkInTempl') {
                        <div class="col-12 col-md-6">
                            @if (shouldAllowWebAttendance) {
                                <button class="w-100" mat-stroked-button (click)="onCheckIn()" color="primary">
                                    {{ 'GeneralMeeting.CheckIn' | translate }}
                                </button>
                            }
                        </div>
                    }
                }
            </div>
        </mat-card-actions>
    } @else {
        <div class="h-100 d-flex align-items-center justify-content-center">
            <mat-spinner [diameter]="32" />
        </div>
    }
</mat-card>
